import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const HEIGHT_FIELD_PARAMS = [
  {
    kind: 'float',
    key: 'amplitude',
    label: 'Amplitude',
    min: 0,
    max: 600,
    step: 1,
    default: 150,
    unit: 'px',
    bulkRange: [40, 320],
    group: 'Höhenfeld',
    tooltip: 'Wie weit die Textfläche in Z ausgelenkt wird.',
  },
  {
    kind: 'float',
    key: 'noiseScale',
    label: 'Noise-Skala',
    min: 0.0004,
    max: 0.02,
    step: 0.0001,
    scale: 'log',
    default: 0.0035,
    precision: 4,
    unit: '1/px',
    group: 'Höhenfeld',
  },
  {
    kind: 'int',
    key: 'octaves',
    label: 'Detailoktaven',
    min: 1,
    max: 6,
    step: 1,
    default: 3,
    group: 'Höhenfeld',
  },
  {
    kind: 'float',
    key: 'resolution',
    label: 'Gitterweite',
    min: 3,
    max: 40,
    step: 1,
    default: 9,
    unit: 'px',
    neverRandomise: true,
    group: 'Höhenfeld',
  },
  {
    kind: 'float',
    key: 'depthBase',
    label: 'Grundtiefe',
    min: -300,
    max: 300,
    step: 1,
    default: 0,
    unit: 'px',
    group: 'Höhenfeld',
    tooltip: 'Verschiebt die ganze Fläche in Z — nützlich in Kombination mit anderen Layern.',
  },

  {
    kind: 'enum',
    key: 'style',
    label: 'Renderstil',
    default: 'wireframe',
    group: 'Darstellung',
    options: [
      { value: 'solid', label: 'Solid' },
      { value: 'wireframe', label: 'Wireframe' },
      { value: 'contours', label: 'Konturlinien' },
      { value: 'points', label: 'Punktwolke' },
    ],
  },
  {
    kind: 'float',
    key: 'lineWidth',
    label: 'Strichstärke',
    min: 0.2,
    max: 6,
    step: 0.1,
    default: 0.7,
    unit: 'px',
    group: 'Darstellung',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 0.85,
    group: 'Darstellung',
  },

  {
    kind: 'float',
    key: 'azimuth',
    label: 'Azimut',
    min: -180,
    max: 180,
    step: 1,
    default: 18,
    unit: '°',
    group: 'Kamera',
  },
  {
    kind: 'float',
    key: 'elevation',
    label: 'Höhenwinkel',
    min: -85,
    max: 85,
    step: 1,
    default: 34,
    unit: '°',
    group: 'Kamera',
  },
  {
    kind: 'float',
    key: 'distance',
    label: 'Distanz',
    min: 0.5,
    max: 6,
    step: 0.05,
    default: 1.7,
    unit: '×',
    group: 'Kamera',
  },
  {
    kind: 'float',
    key: 'fov',
    label: 'Blickwinkel',
    min: 8,
    max: 110,
    step: 1,
    default: 40,
    unit: '°',
    group: 'Kamera',
  },

  {
    kind: 'enum',
    key: 'colorMode',
    label: 'Farbmodus',
    default: 'height',
    group: 'Farbe',
    options: [
      { value: 'solid', label: 'Einfarbig' },
      { value: 'height', label: 'Nach Höhe' },
      { value: 'depth', label: 'Nach Tiefe zur Kamera' },
    ],
  },
  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'blueprint' },
    group: 'Farbe',
  },
] as const satisfies ParamSchema;

export type HeightFieldValues = SchemaValues<typeof HEIGHT_FIELD_PARAMS>;
